export default __webpack_public_path__ + "static/media/logo.dec6ec05.png";